import { render } from "./CallButton.vue?vue&type=template&id=3b3649f4&scoped=true"
import script from "./CallButton.vue?vue&type=script&lang=js"
export * from "./CallButton.vue?vue&type=script&lang=js"

import "./CallButton.vue?vue&type=style&index=0&id=3b3649f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3649f4"]])

export default __exports__